import { COLORS } from "shared/consts";
import styled from "styled-components";
import {CloseIcon} from "shared/ui/icons";
import {Link} from "react-router-dom";

const BaseWrap = styled.div`
    position: absolute;
    top: 0;
    left: 100%;
    width: min(400px, 30vw);
    height: 100vh;
    box-shadow:
            0px 32px 32px 0px ${COLORS.NEUTRAL.CONTAINER_SOFT},
            0px 0px 32px 0px ${COLORS.NEUTRAL.CONTAINER_MUTED};
    background: ${COLORS.BG.SURFACE1};
    z-index: 10;

    display: flex;
    flex-direction: column;
    
    @media screen and (max-width: 1000px) {
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
    }
`;

export const AnimatedWrap = styled(BaseWrap)`
    &.hud-slide-enter {
        opacity: 0;
        transform: translateX(-12px);
    }
    &.hud-slide-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 200ms ease, transform 200ms ease;
    }
    &.hud-slide-exit {
        opacity: 1;
        transform: translateX(0);
    }
    &.hud-slide-exit-active {
        opacity: 0;
        transform: translateX(-12px);
        transition: opacity 150ms ease, transform 150ms ease;
    }
`;

export const SearchModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid ${COLORS.BORDER.MUTED};


    h3 {
        color: ${COLORS.FG.DEFAULT};
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

    svg {
        cursor: pointer;
    }
`

export const SearchModalContent = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
`

export const SearchInputWrapper = styled.div`
    .input.input--primary .input__suffix svg,
    .input.input--primary .input__prefix svg {
        fill: none;
    }
    
    .input__field {
        padding: 0 20px 0 40px;
        margin-inline: 0;
    }

    .input.input--size-m {
        margin-top: 0;
    }
    
    @media screen and (max-width: 1000px) {
        display: flex;
        gap: 16px;
        align-items: center;
        
        span {
            width: 24px;
            height: 24px;
        }
    }
`;

export const SearchInputSuffix = styled(CloseIcon)`
    
`

export const HistoryHeader = styled.div`
    margin-top: 32px;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    
    @media screen and (max-width: 1000px) {
        margin-top: 24px;
    }
`

export const HistoryHeaderTitle = styled.h5`
    color: ${COLORS.FG.DEFAULT};

    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
`

export const HistoryHeaderErase = styled.p`
    cursor: pointer;

    color: ${COLORS.ACCENT.DEFAULT};

    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
`

export const HistoryBody = styled.div`
    display: flex;
    flex-direction: column;
`

export const HistoryElement = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 12px 0;
    gap: 8px;
    
    color: ${COLORS.FG.DEFAULT};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    
    width: 100%;
`

export const HistoryCloseButton = styled.div`
    margin-left: auto;
    width: 16px;
    height: 16px;
    
    svg {
        width: 100%;
        height: 100%;
    }
`

export const SearchBlockWrapper = styled.div`
    display: flex;
    flex-direction: column;
    
    margin-top: 32px;
    
    &:not(:first-of-type) {
        margin-top: 24px;
    }
`

export const SearchBlockHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
    
    h4 {
        color: ${COLORS.FG.DEFAULT};

        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }
`

export const MoreWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    
    p {
        color: ${COLORS.ACCENT.DEFAULT};
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }
`

export const MoreIconWrapper = styled.span`
    transition: transform .3s ease-in-out;
`

export const SearchBlockItem = styled(Link)`
    display: flex;
    width: 100%;
    gap: 12px;
    
    &:not(:last-of-type) {
        margin-bottom: 16px;
    }
`

export const SearchBlockItemIcon = styled.span`
    width: 36px;
    min-width: 36px;
    min-height: 36px;
    height: 36px;
    max-width: 36px;
    max-height: 36px;
    border-radius: 8px;
    background: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
    display: flex;
    justify-content: center;
    align-items: center;
    
    svg {
        width: 20px;
        height: 20px;
    }
`

export const SearchBlockItemCol = styled.div`
    display: flex;
    flex-direction: column;
`

export const SearchBlockItemTitleRow = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 300px;

    h4 {
        color: ${COLORS.FG.DEFAULT};
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;


export const SearchBlockItemDevice = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    height: 100%;
    
    svg {
        width: 20px;
        height: 20px;
    }
    
    p {
        color: ${COLORS.FG.DEFAULT};

        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }
`

export const SearchBlockItemDesc = styled.p`
    color: ${COLORS.FG.MUTED};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
`